'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002423 from "./presto.-Two-Factor-Auth-View$$anon$23.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024 from "./presto.types$-Two-Factor-Auth$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$22() {
  this.bAS = null;
  this.bAK = null;
  this.bAL = false;
  this.bAT = null;
  this.bAU = false;
  this.bAX = null;
  this.bAQ = null;
  this.bAR = false;
  this.bAM = null;
  this.bAN = false;
  this.bAO = null;
  this.bAP = false;
  this.bAV = false;
  this.bAW = false;
  this.bAS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bAX = "TwoFactorAuth";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$22 as $c_Lpresto_TwoFactorAuthView$$anon$22 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$22;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$22() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$22 as $h_Lpresto_TwoFactorAuthView$$anon$22 };
$h_Lpresto_TwoFactorAuthView$$anon$22.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bAS;
});
$p.L = (function() {
  if ((!this.bAL)) {
    this.bAK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bAL = true;
  }
  return this.bAK;
});
$p.O = (function() {
  if ((!this.bAU)) {
    this.bAT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bAU = true;
  }
  return this.bAT;
});
$p.E = (function() {
  return this.bAX;
});
$p.t = (function() {
  if ((!this.bAR)) {
    this.bAQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bAR = true;
  }
  return this.bAQ;
});
$p.M = (function() {
  if ((!this.bAN)) {
    this.bAM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().zb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().zc(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024.$m_Lpresto_types$TwoFactorAuthType$().ze(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthPayload$().zd(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bAN = true;
  }
  return this.bAM;
});
$p.Q = (function() {
  if ((!this.bAP)) {
    this.bAO = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002423.$c_Lpresto_TwoFactorAuthView$$anon$23();
    this.bAP = true;
  }
  return this.bAO;
});
$p.w = (function() {
  if ((!this.bAW)) {
    this.bAV = false;
    this.bAW = true;
  }
  return this.bAV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee115) => ((p) => \u03b4scrutinee115.z2(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_types$TwoFactorAuth$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$22, "presto.TwoFactorAuthView$$anon$22", ({
  Si: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$22 as $d_Lpresto_TwoFactorAuthView$$anon$22 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$22.js.map
